import { render } from "./card.vue?vue&type=template&id=73bfedc6&scoped=true"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"

import "./card.vue?vue&type=style&index=0&id=73bfedc6&scoped=true&lang=css"

import exportComponent from "/Users/projects/crud/liderombor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73bfedc6"]])

export default __exports__